import { absoluteApiV1Path } from '../lib/api'

/** slug별 서버 내장 HTML·PDF (DB와 동일 규칙). */
function builtinManualUrls(slug) {
  return {
    viewUrl: absoluteApiV1Path(`public/support-guide/manuals/by-slug/${slug}/html`),
    downloadUrl: absoluteApiV1Path(`public/support-guide/manuals/by-slug/${slug}/pdf`),
  }
}

/**
 * 이용 가이드 — API 실패 시에만 쓰는 폴백 데이터.
 * 운영 반영 값은 DB(`support_guide_manuals`) + `/public/support-guide/manuals` 입니다.
 */
export const supportGuideManualFallbackItems = [
  {
    id: 'dashboard',
    title: '대시보드·업무 현황',
    summary: '조직/개인 홈에서 확인하는 지표와 바로가기 흐름입니다.',
    ...builtinManualUrls('dashboard'),
  },
  {
    id: 'requests',
    title: '설계의뢰',
    summary: '의뢰 생성, 상태 변경, 첨부·코멘트, 공유 링크(정책 허용 시) 안내.',
    ...builtinManualUrls('requests'),
  },
  {
    id: 'customers',
    title: '고객관리',
    summary: '고객 등록·조회, 진료분석·설문과 연결하는 방법입니다.',
    ...builtinManualUrls('customers'),
  },
  {
    id: 'health',
    title: '진료정보분석',
    summary: '리포트 요청·열람, 예외 문구·주의사항을 정리합니다.',
    ...builtinManualUrls('health'),
  },
  {
    id: 'sales',
    title: '영업·리드',
    summary: '상담 설문, 리드/문의 DB, 영업 자료 활용 방법입니다.',
    ...builtinManualUrls('sales'),
  },
  {
    id: 'support-tools',
    title: '고객지원 도구',
    summary: '단체문자·카카오 단체발송, 보험금 청구 안내, 설문 관리 개요.',
    ...builtinManualUrls('support-tools'),
  },
  {
    id: 'org-admin',
    title: '조직·권한·구독',
    summary: '조직 구성, 역할, 구독/결제 메뉴와 연관된 운영 흐름입니다.',
    ...builtinManualUrls('org-admin'),
  },
]
